import { useCookieStore } from '@uncinc/uncinc-react-kitchen-sink';

// Matches COOKIE_CONSENT_STATE from @uncinc/uncinc-react-kitchen-sink
const COOKIE_CONSENT_STATE_KEY = 'cookie_consent_state';
// Matches LocalConsentStatus.STATUS_EDITING from the same package
const STATUS_EDITING = '3';

const useCookie = () => {
  const [, setConsent] = useCookieStore(COOKIE_CONSENT_STATE_KEY);

  const updateConsent = () => {
    setConsent(JSON.stringify({ status: STATUS_EDITING, version: '1.0.0' }));
  };

  return { updateConsent };
};

export default useCookie;
